// extracted by mini-css-extract-plugin
export default {"closeButton":"nvgB0"};